import {IOffer} from '../../interfaces/HotelReservationV2/IOffer';
import {IProductUse} from '../../interfaces/HotelReservationV2/IProductUse';

export class OfferBuilder {
    private _offer: IOffer;
    constructor() {
        this._offer = <IOffer>{};
        this._offer.productUses = []; //<IOffer>
    }
    withRatePlanCode (ratePlanCode: string) {
        this._offer.ratePlanCode = ratePlanCode;
        delete this._offer.groupContractCode;
        return this;
    }

    withGroupCode (groupCode: string) {
      this._offer.groupContractCode = groupCode;
      delete this._offer.ratePlanCode;
      return this;
    }

    withProductUse (productUse: IProductUse) {
        this._offer.productUses.splice(0,1,productUse);
        return this;
    }

    build (): IOffer {
        return this._offer;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/offer.builder.ts